import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import ProductComparisonTable from '../ProductComparasion';
import { showSpringOffer } from '@/utils/springOffer';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
import { useBnplLimitsMinimal } from '@/api/skippay/featureFlags';
function FilledComparisonTable() {
  const $ = _c(251);
  const {
    t
  } = useTranslation("ourProducts");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = showSpringOffer();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowSpringOffer = t0;
  const isBnplLimitsMinimalEnabled = useBnplLimitsMinimal();
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div id="maxi" />;
    t2 = <div id="mini" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bgCircle absolute top-1/2 right-0 hidden translate-x-1/4 -translate-y-1/2 rotate-90 md:block" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("comparisonTable.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <SectionHeadline className="mb-12 md:mb-16" anchorKey="ourProducts.comparisonTable.title">{t4}</SectionHeadline>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("comparisonTable.columns.mini.title");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("comparisonTable.columns.maxi.title");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("comparisonTable.columns.noPackage.title");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = {
      left: t6,
      center: t7,
      right: t8
    };
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("comparisonTable.categories.1.title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("comparisonTable.categories.1.items.1.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("comparisonTable.categories.1.items.1.tooltip");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = {
      title: t11,
      tooltip: t12,
      left: true,
      center: true,
      right: true
    };
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("comparisonTable.categories.1.items.2.title");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("comparisonTable.categories.1.items.2.tooltip");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = {
      title: t14,
      tooltip: t15,
      left: true,
      center: true,
      right: true
    };
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("comparisonTable.categories.1.items.3.title");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("comparisonTable.categories.1.items.3.tooltip");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = {
      title: t17,
      tooltip: t18,
      left: true,
      center: true,
      right: false
    };
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("comparisonTable.categories.1.items.4.title");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t("comparisonTable.categories.1.items.4.tooltip");
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = {
      title: t20,
      tooltip: t21,
      left: false,
      center: true,
      right: false
    };
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("comparisonTable.categories.1.items.5.title");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("comparisonTable.categories.1.items.5.tooltip");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t23 || $[53] !== t24) {
    t25 = {
      title: t23,
      tooltip: t24,
      left: false,
      center: true,
      right: false
    };
    $[52] = t23;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t13 || $[56] !== t16 || $[57] !== t19 || $[58] !== t22 || $[59] !== t25) {
    t26 = [t13, t16, t19, t22, t25];
    $[55] = t13;
    $[56] = t16;
    $[57] = t19;
    $[58] = t22;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t10 || $[62] !== t26) {
    t27 = {
      title: t10,
      items: t26
    };
    $[61] = t10;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t) {
    t28 = t("comparisonTable.categories.2.title");
    $[64] = t;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t) {
    t29 = t("comparisonTable.categories.2.items.1.title");
    $[66] = t;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t) {
    t30 = t("comparisonTable.categories.2.items.1.tooltip");
    $[68] = t;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t29 || $[71] !== t30) {
    t31 = {
      title: t29,
      tooltip: t30,
      left: true,
      center: true,
      right: true
    };
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t) {
    t32 = t("comparisonTable.categories.2.items.2.title");
    $[73] = t;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t) {
    t33 = t("comparisonTable.categories.2.items.2.tooltip");
    $[75] = t;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t32 || $[78] !== t33) {
    t34 = {
      title: t32,
      tooltip: t33,
      left: true,
      center: true,
      right: false
    };
    $[77] = t32;
    $[78] = t33;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t("comparisonTable.categories.2.items.3.title");
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t) {
    t36 = t("comparisonTable.categories.2.items.3.tooltip");
    $[82] = t;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t35 || $[85] !== t36) {
    t37 = {
      title: t35,
      tooltip: t36,
      left: false,
      center: true,
      right: false
    };
    $[84] = t35;
    $[85] = t36;
    $[86] = t37;
  } else {
    t37 = $[86];
  }
  let t38;
  if ($[87] !== isBnplLimitsMinimalEnabled || $[88] !== t) {
    t38 = !isBnplLimitsMinimalEnabled ? [{
      title: t("comparisonTable.categories.2.items.4.title"),
      tooltip: t("comparisonTable.categories.2.items.4.tooltip"),
      left: t("comparisonTable.categories.2.items.4.left"),
      center: t("comparisonTable.categories.2.items.4.center"),
      right: t("comparisonTable.categories.2.items.4.right")
    }] : [];
    $[87] = isBnplLimitsMinimalEnabled;
    $[88] = t;
    $[89] = t38;
  } else {
    t38 = $[89];
  }
  let t39;
  if ($[90] !== t) {
    t39 = t("comparisonTable.categories.2.items.5.title");
    $[90] = t;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t) {
    t40 = t("comparisonTable.categories.2.items.5.tooltip");
    $[92] = t;
    $[93] = t40;
  } else {
    t40 = $[93];
  }
  let t41;
  if ($[94] !== t) {
    t41 = t("comparisonTable.categories.2.items.5.left");
    $[94] = t;
    $[95] = t41;
  } else {
    t41 = $[95];
  }
  let t42;
  if ($[96] !== t) {
    t42 = t("comparisonTable.categories.2.items.5.center");
    $[96] = t;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] !== t) {
    t43 = t("comparisonTable.categories.2.items.5.right");
    $[98] = t;
    $[99] = t43;
  } else {
    t43 = $[99];
  }
  let t44;
  if ($[100] !== t39 || $[101] !== t40 || $[102] !== t41 || $[103] !== t42 || $[104] !== t43) {
    t44 = {
      title: t39,
      tooltip: t40,
      left: t41,
      center: t42,
      right: t43
    };
    $[100] = t39;
    $[101] = t40;
    $[102] = t41;
    $[103] = t42;
    $[104] = t43;
    $[105] = t44;
  } else {
    t44 = $[105];
  }
  let t45;
  if ($[106] !== t31 || $[107] !== t34 || $[108] !== t37 || $[109] !== t38 || $[110] !== t44) {
    t45 = [t31, t34, t37, ...t38, t44];
    $[106] = t31;
    $[107] = t34;
    $[108] = t37;
    $[109] = t38;
    $[110] = t44;
    $[111] = t45;
  } else {
    t45 = $[111];
  }
  let t46;
  if ($[112] !== t28 || $[113] !== t45) {
    t46 = {
      title: t28,
      items: t45
    };
    $[112] = t28;
    $[113] = t45;
    $[114] = t46;
  } else {
    t46 = $[114];
  }
  let t47;
  if ($[115] !== t) {
    t47 = t("comparisonTable.categories.3.title");
    $[115] = t;
    $[116] = t47;
  } else {
    t47 = $[116];
  }
  let t48;
  if ($[117] !== t) {
    t48 = t("comparisonTable.categories.3.items.1.title");
    $[117] = t;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  let t49;
  if ($[119] !== t) {
    t49 = t("comparisonTable.categories.3.items.1.tooltip");
    $[119] = t;
    $[120] = t49;
  } else {
    t49 = $[120];
  }
  let t50;
  if ($[121] !== t48 || $[122] !== t49) {
    t50 = {
      title: t48,
      tooltip: t49,
      left: true,
      center: true,
      right: false
    };
    $[121] = t48;
    $[122] = t49;
    $[123] = t50;
  } else {
    t50 = $[123];
  }
  let t51;
  if ($[124] !== t) {
    t51 = t("comparisonTable.categories.3.items.2.title");
    $[124] = t;
    $[125] = t51;
  } else {
    t51 = $[125];
  }
  let t52;
  if ($[126] !== t) {
    t52 = t("comparisonTable.categories.3.items.2.tooltip");
    $[126] = t;
    $[127] = t52;
  } else {
    t52 = $[127];
  }
  let t53;
  if ($[128] !== t51 || $[129] !== t52) {
    t53 = {
      title: t51,
      tooltip: t52,
      left: true,
      center: true,
      right: false
    };
    $[128] = t51;
    $[129] = t52;
    $[130] = t53;
  } else {
    t53 = $[130];
  }
  let t54;
  if ($[131] !== t) {
    t54 = t("comparisonTable.categories.3.items.3.title");
    $[131] = t;
    $[132] = t54;
  } else {
    t54 = $[132];
  }
  let t55;
  if ($[133] !== t) {
    t55 = t("comparisonTable.categories.3.items.3.tooltip");
    $[133] = t;
    $[134] = t55;
  } else {
    t55 = $[134];
  }
  let t56;
  if ($[135] !== t) {
    t56 = t("comparisonTable.categories.3.items.3.left");
    $[135] = t;
    $[136] = t56;
  } else {
    t56 = $[136];
  }
  let t57;
  if ($[137] !== t) {
    t57 = t("comparisonTable.categories.3.items.3.center");
    $[137] = t;
    $[138] = t57;
  } else {
    t57 = $[138];
  }
  let t58;
  if ($[139] !== t) {
    t58 = t("comparisonTable.categories.3.items.3.right");
    $[139] = t;
    $[140] = t58;
  } else {
    t58 = $[140];
  }
  let t59;
  if ($[141] !== t54 || $[142] !== t55 || $[143] !== t56 || $[144] !== t57 || $[145] !== t58) {
    t59 = {
      title: t54,
      tooltip: t55,
      left: t56,
      center: t57,
      right: t58
    };
    $[141] = t54;
    $[142] = t55;
    $[143] = t56;
    $[144] = t57;
    $[145] = t58;
    $[146] = t59;
  } else {
    t59 = $[146];
  }
  let t60;
  if ($[147] !== t) {
    t60 = t("comparisonTable.categories.3.items.4.title");
    $[147] = t;
    $[148] = t60;
  } else {
    t60 = $[148];
  }
  let t61;
  if ($[149] !== t) {
    t61 = t("comparisonTable.categories.3.items.4.tooltip");
    $[149] = t;
    $[150] = t61;
  } else {
    t61 = $[150];
  }
  let t62;
  if ($[151] !== t) {
    t62 = t("comparisonTable.categories.3.items.4.left");
    $[151] = t;
    $[152] = t62;
  } else {
    t62 = $[152];
  }
  let t63;
  if ($[153] !== t) {
    t63 = t("comparisonTable.categories.3.items.4.center");
    $[153] = t;
    $[154] = t63;
  } else {
    t63 = $[154];
  }
  let t64;
  if ($[155] !== t) {
    t64 = t("comparisonTable.categories.3.items.4.right");
    $[155] = t;
    $[156] = t64;
  } else {
    t64 = $[156];
  }
  let t65;
  if ($[157] !== t60 || $[158] !== t61 || $[159] !== t62 || $[160] !== t63 || $[161] !== t64) {
    t65 = {
      title: t60,
      tooltip: t61,
      left: t62,
      center: t63,
      right: t64
    };
    $[157] = t60;
    $[158] = t61;
    $[159] = t62;
    $[160] = t63;
    $[161] = t64;
    $[162] = t65;
  } else {
    t65 = $[162];
  }
  let t66;
  if ($[163] !== t) {
    t66 = t("comparisonTable.categories.3.items.5.title");
    $[163] = t;
    $[164] = t66;
  } else {
    t66 = $[164];
  }
  let t67;
  if ($[165] !== t) {
    t67 = t("comparisonTable.categories.3.items.5.tooltip");
    $[165] = t;
    $[166] = t67;
  } else {
    t67 = $[166];
  }
  let t68;
  if ($[167] !== t66 || $[168] !== t67) {
    t68 = {
      title: t66,
      tooltip: t67,
      left: false,
      center: true,
      right: false
    };
    $[167] = t66;
    $[168] = t67;
    $[169] = t68;
  } else {
    t68 = $[169];
  }
  let t69;
  if ($[170] !== t) {
    t69 = t("comparisonTable.categories.3.items.6.title");
    $[170] = t;
    $[171] = t69;
  } else {
    t69 = $[171];
  }
  let t70;
  if ($[172] !== t) {
    t70 = t("comparisonTable.categories.3.items.6.tooltip");
    $[172] = t;
    $[173] = t70;
  } else {
    t70 = $[173];
  }
  let t71;
  if ($[174] !== t69 || $[175] !== t70) {
    t71 = {
      title: t69,
      tooltip: t70,
      left: false,
      center: true,
      right: false
    };
    $[174] = t69;
    $[175] = t70;
    $[176] = t71;
  } else {
    t71 = $[176];
  }
  let t72;
  if ($[177] !== t) {
    t72 = shouldShowSpringOffer && {
      title: t("comparisonTable.categories.3.items.spring.title"),
      tooltip: t("comparisonTable.categories.3.items.spring.tooltip", SPRING_OFFER_TRANSLATION_VALUES),
      left: false,
      center: true,
      right: false
    };
    $[177] = t;
    $[178] = t72;
  } else {
    t72 = $[178];
  }
  let t73;
  if ($[179] !== t50 || $[180] !== t53 || $[181] !== t59 || $[182] !== t65 || $[183] !== t68 || $[184] !== t71 || $[185] !== t72) {
    t73 = [t50, t53, t59, t65, t68, t71, t72].filter(Boolean);
    $[179] = t50;
    $[180] = t53;
    $[181] = t59;
    $[182] = t65;
    $[183] = t68;
    $[184] = t71;
    $[185] = t72;
    $[186] = t73;
  } else {
    t73 = $[186];
  }
  let t74;
  if ($[187] !== t47 || $[188] !== t73) {
    t74 = {
      title: t47,
      items: t73
    };
    $[187] = t47;
    $[188] = t73;
    $[189] = t74;
  } else {
    t74 = $[189];
  }
  let t75;
  if ($[190] !== t) {
    t75 = t("comparisonTable.categories.4.title");
    $[190] = t;
    $[191] = t75;
  } else {
    t75 = $[191];
  }
  let t76;
  if ($[192] !== t) {
    t76 = t("comparisonTable.categories.4.items.1.title");
    $[192] = t;
    $[193] = t76;
  } else {
    t76 = $[193];
  }
  let t77;
  if ($[194] !== t) {
    t77 = t("comparisonTable.categories.4.items.1.tooltip");
    $[194] = t;
    $[195] = t77;
  } else {
    t77 = $[195];
  }
  let t78;
  if ($[196] !== t76 || $[197] !== t77) {
    t78 = {
      title: t76,
      tooltip: t77,
      left: true,
      center: true,
      right: true
    };
    $[196] = t76;
    $[197] = t77;
    $[198] = t78;
  } else {
    t78 = $[198];
  }
  let t79;
  if ($[199] !== t) {
    t79 = t("comparisonTable.categories.4.items.2.title");
    $[199] = t;
    $[200] = t79;
  } else {
    t79 = $[200];
  }
  let t80;
  if ($[201] !== t) {
    t80 = t("comparisonTable.categories.4.items.2.tooltip");
    $[201] = t;
    $[202] = t80;
  } else {
    t80 = $[202];
  }
  let t81;
  if ($[203] !== t79 || $[204] !== t80) {
    t81 = {
      title: t79,
      tooltip: t80,
      left: false,
      center: true,
      right: false
    };
    $[203] = t79;
    $[204] = t80;
    $[205] = t81;
  } else {
    t81 = $[205];
  }
  let t82;
  if ($[206] !== t) {
    t82 = t("comparisonTable.categories.4.items.3.title");
    $[206] = t;
    $[207] = t82;
  } else {
    t82 = $[207];
  }
  let t83;
  if ($[208] !== t) {
    t83 = t("comparisonTable.categories.4.items.3.tooltip");
    $[208] = t;
    $[209] = t83;
  } else {
    t83 = $[209];
  }
  let t84;
  if ($[210] !== t82 || $[211] !== t83) {
    t84 = {
      title: t82,
      tooltip: t83,
      left: false,
      center: true,
      right: false
    };
    $[210] = t82;
    $[211] = t83;
    $[212] = t84;
  } else {
    t84 = $[212];
  }
  let t85;
  if ($[213] !== t) {
    t85 = t("comparisonTable.categories.4.items.4.title");
    $[213] = t;
    $[214] = t85;
  } else {
    t85 = $[214];
  }
  let t86;
  if ($[215] !== t) {
    t86 = t("comparisonTable.categories.4.items.4.tooltip");
    $[215] = t;
    $[216] = t86;
  } else {
    t86 = $[216];
  }
  let t87;
  if ($[217] !== t85 || $[218] !== t86) {
    t87 = {
      title: t85,
      tooltip: t86,
      left: false,
      center: true,
      right: false
    };
    $[217] = t85;
    $[218] = t86;
    $[219] = t87;
  } else {
    t87 = $[219];
  }
  let t88;
  if ($[220] !== t78 || $[221] !== t81 || $[222] !== t84 || $[223] !== t87) {
    t88 = [t78, t81, t84, t87];
    $[220] = t78;
    $[221] = t81;
    $[222] = t84;
    $[223] = t87;
    $[224] = t88;
  } else {
    t88 = $[224];
  }
  let t89;
  if ($[225] !== t75 || $[226] !== t88) {
    t89 = {
      title: t75,
      items: t88
    };
    $[225] = t75;
    $[226] = t88;
    $[227] = t89;
  } else {
    t89 = $[227];
  }
  let t90;
  if ($[228] !== t27 || $[229] !== t46 || $[230] !== t74 || $[231] !== t89) {
    t90 = [t27, t46, t74, t89];
    $[228] = t27;
    $[229] = t46;
    $[230] = t74;
    $[231] = t89;
    $[232] = t90;
  } else {
    t90 = $[232];
  }
  let t91;
  if ($[233] !== t9 || $[234] !== t90) {
    t91 = <ProductComparisonTable activeColumn="center" titles={t9} categories={t90} />;
    $[233] = t9;
    $[234] = t90;
    $[235] = t91;
  } else {
    t91 = $[235];
  }
  let t92;
  if ($[236] !== t) {
    t92 = t("comparisonTable.text");
    $[236] = t;
    $[237] = t92;
  } else {
    t92 = $[237];
  }
  let t93;
  if ($[238] !== t92) {
    t93 = <Text variant="p4" className="my-10 text-center">{t92}</Text>;
    $[238] = t92;
    $[239] = t93;
  } else {
    t93 = $[239];
  }
  let t94;
  if ($[240] === Symbol.for("react.memo_cache_sentinel")) {
    t94 = <div className="mx-auto mt-4 max-w-[47.5rem] md:my-16 lg:my-12"><RepresentativeExample className="bg-blue-50" /></div>;
    $[240] = t94;
  } else {
    t94 = $[240];
  }
  let t95;
  if ($[241] === Symbol.for("react.memo_cache_sentinel")) {
    t95 = LINKS();
    $[241] = t95;
  } else {
    t95 = $[241];
  }
  const t96 = t95.registration;
  let t97;
  if ($[242] !== t) {
    t97 = t("comparisonTable.cta");
    $[242] = t;
    $[243] = t97;
  } else {
    t97 = $[243];
  }
  let t98;
  if ($[244] !== t97) {
    t98 = <div className="pt-4"><Button variant="primary" align="center" size="lg" to={t96} testId="accountsRegistration" analyticsParam="accountsRegistration">{t97}</Button></div>;
    $[244] = t97;
    $[245] = t98;
  } else {
    t98 = $[245];
  }
  let t99;
  if ($[246] !== t5 || $[247] !== t91 || $[248] !== t93 || $[249] !== t98) {
    t99 = <>{t1}{t2}<div className="relative px-4" id="comparison-table">{t3}<div className="relative z-10">{t5}{t91}{t93}{t94}{t98}</div></div></>;
    $[246] = t5;
    $[247] = t91;
    $[248] = t93;
    $[249] = t98;
    $[250] = t99;
  } else {
    t99 = $[250];
  }
  return t99;
}
export default FilledComparisonTable;